import http from '@/http/http'
import apiCfg from '../../config'

function requestAi(url, params) {
  return http.post(url, params, { timeout: 20000 }).then(res => {
    const body = res.data
    if (body && Object.prototype.hasOwnProperty.call(body, 'code') && body.code !== 'ok') {
      const err = new Error(body.message || '请求失败')
      err.businessCode = body.code
      return Promise.reject(err)
    }
    return res
  })
}

/** 解析 AI 成功响应正文 */
export function parseAiResponsePayload(response) {
  if (!response || !response.data) return { content: '', skillId: '' }
  const body = response.data
  const payload = body.data != null ? body.data : body
  if (typeof payload === 'string') return { content: payload, skillId: '' }
  if (!payload || typeof payload !== 'object') return { content: '', skillId: '' }
  return {
    content: payload.content || payload.result || payload.message || '',
    skillId: payload.skillId || ''
  }
}

export default {
  chat(message) {
    return requestAi(apiCfg.portalApi + '/ai/chat', { message })
  }
}
